// How often to re-check the BFF's hotload status endpoint while a load is still in progress.
export const HOTLOAD_POLL_INTERVAL_MS = 300;
// How long to wait before giving up on a load and letting the gated view fall through to its own
// loading / empty states. We never want to trap a user on a spinner indefinitely.
export const HOTLOAD_TIMEOUT_MS = 120_000;

// The five states the BFF's (and FQS's) hotload status endpoints report for a UPID's presence in
// hotstorage. `partially_hotloaded` means at least one FQS-supported type is not loaded, the normal
// end state when only the app's types are requested. `hotloaded_with_omissions` means every
// resource type loaded, but at least one type skipped individual resources along the way — it is
// rollup-only, a per-type entry in `resourceTypes` never carries this value.
export type HotloadState =
  | 'not_hotloaded'
  | 'hotloading'
  | 'hotloaded'
  | 'partially_hotloaded'
  | 'hotloaded_with_omissions';

// States that will never change again this session: nothing left to poll for. `not_hotloaded` and
// `hotloading` are excluded, since those are the only states a load can still progress out of.
export const TERMINAL_HOTLOAD_STATES: ReadonlySet<string> = new Set<HotloadState>([
  'hotloaded',
  'partially_hotloaded',
  'hotloaded_with_omissions',
]);

export const isTerminalHotloadState = (state?: HotloadState): boolean =>
  state !== undefined && TERMINAL_HOTLOAD_STATES.has(state);
